// import React from "react";
// import {
//   Users,
//   Target,
//   Award,
//   Globe,
//   BookOpen,
//   Heart,
//   TrendingUp,
//   CheckCircle,
//   Lightbulb,
//   Shield,
//   Clock,
//   Star,
// } from "lucide-react";

// function About() {
//   const teamMembers = [
//     {
//       name: "Ahmet Yılmaz",
//       role: "Kurucu & CEO",
//       image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ahmet",
//     },
//     {
//       name: "Zeynep Kaya",
//       role: "Eğitim Direktörü",
//       image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Zeynep",
//     },
//     {
//       name: "Mehmet Demir",
//       role: "Teknoloji Lideri",
//       image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Mehmet",
//     },
//     {
//       name: "Elif Şahin",
//       role: "İçerik Geliştirme",
//       image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Elif",
//     },
//   ];

//   const values = [
//     {
//       icon: <Heart className="w-6 h-6" />,
//       title: "Öğrenci Odaklılık",
//       description: "Her kararımızın merkezinde öğrenci başarısı var",
//     },
//     {
//       icon: <Lightbulb className="w-6 h-6" />,
//       title: "Yenilikçilik",
//       description: "Eğitim teknolojilerinde sınırları zorluyoruz",
//     },
//     {
//       icon: <Shield className="w-6 h-6" />,
//       title: "Güvenilirlik",
//       description: "Veri güvenliği ve gizlilik en yüksek önceliğimiz",
//     },
//     {
//       icon: <Users className="w-6 h-6" />,
//       title: "İşbirliği",
//       description: "Birlikte daha iyisini başarıyoruz",
//     },
//   ];

//   const milestones = [
//     {
//       year: "2026",
//       title: "Kuruluş",
//       description: "Classroom projesi başlatıldı",
//     },
//     {
//       year: "2026",
//       title: "Beta Yayın",
//       description: "İlk 1000 kullanıcıya ulaşıldı",
//     },
//     {
//       year: "2026",
//       title: "Mobil Uygulama",
//       description: "iOS ve Android uygulamaları yayınlandı",
//     },
//     {
//       year: "2026",
//       title: "100K+ Kullanıcı",
//       description: "Türkiye genelinde yaygın kullanım",
//     },
//   ];

//   return (
//     <div className="min-h-screen  px-4 py-12">
//       <div className="max-w-7xl mx-auto">
//         {/* Hero Bölümü */}
//         <div className="text-center mb-16">
//           <div
//             className="inline-flex items-center gap-2 bg-purple-500
//            text-white font-normal px-4 py-2 rounded-full mb-6"
//           >
//             <BookOpen className="w-5 h-5 text-yellow-300" />
//             <span className="font-semibold">Eğitimde Devrim</span>
//           </div>

//           <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
//             Eğitimi<span className="text-gray-900"> Dönüştürüyoruz</span>
//           </h1>

//           <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
//             2026'den beri öğretmen ve öğrencilerin buluştuğu dijital platform
//             olarak, eğitim deneyimini yeniden tanımlıyoruz. Her gün binlerce
//             sınıfı bir araya getiriyoruz.
//           </p>
//         </div>

//         {/* İstatistikler */}
//         {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
//           <div className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100 text-center">
//             <div className="text-3xl font-bold text-slate-700 mb-2">50K+</div>
//             <div className="text-gray-600 font-medium">Aktif Öğrenci</div>
//           </div>

//           <div className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100 text-center">
//             <div className="text-3xl font-bold text-slate-700 mb-2">3K+</div>
//             <div className="text-gray-600 font-medium">Eğitmen</div>
//           </div>

//           <div className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100 text-center">
//             <div className="text-3xl font-bold text-slate-700 mb-2">150K+</div>
//             <div className="text-gray-600 font-medium">Tamamlanan Ders</div>
//           </div>

//           <div className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100 text-center">
//             <div className="text-3xl font-bold text-slate-700 mb-2">%98</div>
//             <div className="text-gray-600 font-medium">Memnuniyet Oranı</div>
//           </div>
//         </div> */}

//         {/* Misyon & Vizyon */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
//           <div className="bg-yellow-500 rounded-2xl p-8 shadow-xl border border-emerald-100">
//             <div className="flex items-center gap-4 mb-6">
//               <div className="bg-blue-100 p-3 rounded-full">
//                 <Target className="w-8 h-8 text-blue-600" />
//               </div>
//               <h2 className="text-3xl font-bold text-gray-900">Misyonumuz</h2>
//             </div>
//             <p className="text-white font-normal text-lg leading-relaxed mb-6">
//               Her bireyin potansiyelini ortaya çıkaracak eğitim fırsatlarına
//               erişimini sağlamak. Teknolojiyi kullanarak öğrenmeyi daha
//               etkileşimli, erişilebilir ve keyifli hale getiriyoruz.
//             </p>
//             <ul className="space-y-3">
//               {[
//                 "Erişilebilir eğitim",
//                 "Kişiselleştirilmiş öğrenme",
//                 "Sürekli yenilik",
//                 "Topluluk odaklı",
//               ].map((item, index) => (
//                 <li key={index} className="flex items-center gap-3">
//                   <CheckCircle className="w-5 h-5 text-blue-600" />
//                   <span className="text-white font-normal">{item}</span>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div className="bg-purple-500 rounded-2xl p-8 shadow-xl border border-blue-100">
//             <div className="flex items-center gap-4 mb-6">
//               <div className="bg-blue-100 p-3 rounded-full">
//                 <Globe className="w-8 h-8 text-blue-600" />
//               </div>
//               <h2 className="text-3xl font-bold text-gray-900">Vizyonumuz</h2>
//             </div>
//             <p className="text-white font-normal text-lg leading-relaxed mb-6">
//               2030 yılına kadar Türkiye'nin en etkili eğitim platformu olmak ve
//               küresel çapta milyonlarca öğrenciye ulaşmak. Eğitimde dijital
//               dönüşümün öncüsü olarak, geleceğin öğrenme deneyimini
//               şekillendiriyoruz.
//             </p>
//             <div className="bg-blue-50 p-4 rounded-xl">
//               <div className="flex items-center gap-3">
//                 <TrendingUp className="w-6 h-6 text-blue-600" />
//                 <div>
//                   <h4 className="font-bold text-gray-900">Büyüme Hedefimiz</h4>
//                   <p className="text-sm text-gray-600">
//                     Önümüzdeki 3 yılda 1 milyon aktif kullanıcı
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Değerlerimiz */}
//         <div className="mb-16">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-900 mb-4">
//               Değerlerimiz
//             </h2>
//             <p className="text-gray-600 text-lg max-w-2xl mx-auto">
//               Başarımızın arkasında yatan temel prensipler ve inandıklarımız
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {values.map((value, index) => (
//               <div
//                 key={index}
//                 className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100
//                 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
//               >
//                 <div
//                   className="bg-purple-500 text-white w-14 h-14
//                 rounded-xl flex items-center justify-center mb-4"
//                 >
//                   {value.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-3">
//                   {value.title}
//                 </h3>
//                 <p className="text-gray-600">{value.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Tarihçe */}
//         <div className="mb-16">
//           <div className="flex items-center justify-between mb-8">
//             <div>
//               <h2 className="text-4xl font-bold text-gray-900 mb-2">
//                 Yolculuğumuz
//               </h2>
//               <p className="text-gray-600">
//                 Başlangıçtan bugüne önemli kilometre taşları
//               </p>
//             </div>
//             <Clock className="w-8 h-8 text-purple-500" />
//           </div>

//           <div className="relative">
//             {/* Timeline çizgisi */}
//             <div
//               className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 h-full w-1
//             bg-yellow-500"
//             ></div>

//             <div className="space-y-12">
//               {milestones.map((milestone, index) => (
//                 <div
//                   key={index}
//                   className={`relative flex flex-col md:flex-row items-center ${
//                     index % 2 === 0 ? "md:flex-row-reverse" : ""
//                   }`}
//                 >
//                   {/* Nokta */}
//                   <div
//                     className="absolute left-1/2 transform -translate-x-1/2
//                    md:left-1/2 w-4 h-4 bg-purple-500 rounded-full
//                    border-4 border-white z-10"
//                   ></div>

//                   {/* İçerik */}
//                   <div
//                     className={`md:w-5/12 ${
//                       index % 2 === 0 ? "md:pr-12" : "md:pl-12"
//                     }`}
//                   >
//                     <div className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100">
//                       <div
//                         className="inline-block bg-purple-500 text-white
//                       px-3 py-1 rounded-full text-sm font-semibold mb-3"
//                       >
//                         {milestone.year}
//                       </div>
//                       <h3 className="text-xl font-bold text-gray-900 mb-2">
//                         {milestone.title}
//                       </h3>
//                       <p className="text-gray-600">{milestone.description}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Ekibimiz */}
//         {/* <div className="mb-16">
//           <div className="text-center mb-12">
//             <div
//               className="inline-flex items-center gap-2 bg-purple-500 text-white
//              px-4 py-2 rounded-full mb-4"
//             >
//               <Users className="w-5 h-5" />
//               <span className="font-semibold text-white">Uzman Kadro</span>
//             </div>
//             <h2 className="text-4xl font-bold text-gray-900 mb-4">
//               Ekibimizle Tanışın
//             </h2>
//             <p className="text-gray-600 text-lg max-w-2xl mx-auto">
//               Eğitim ve teknoloji alanında deneyimli uzmanlardan oluşan
//               ekibimiz, sürekli olarak platformumuzu geliştirmek için çalışıyor.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {teamMembers.map((member, index) => (
//               <div
//                 key={index}
//                 className="bg-gray-100 rounded-2xl p-6 shadow-lg border
//                  border-gray-100 text-center hover:shadow-xl transition-all
//                   duration-300 hover:-translate-y-2"
//               >
//                 <div
//                   className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden
//                  border-4 border-yellow-500"
//                 >
//                   <img
//                     src={member.image}
//                     alt={member.name}
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-1">
//                   {member.name}
//                 </h3>
//                 <p className="text-purple-500 font-medium mb-4">
//                   {member.role}
//                 </p>
//                 <div className="flex justify-center gap-2">
//                   <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
//                   <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
//                   <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div> */}

//         {/* Başarılar ve Ödüller */}
//         {/* <div className="bg-yellow-500 rounded-2xl p-8 shadow-xl mb-12">
//           <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
//             <div className="lg:w-2/3 text-white">
//               <div className="flex items-center gap-3 mb-4">
//                 <Award className="w-8 h-8 text-white" />
//                 <h2 className="text-3xl font-bold">Tanınmış Başarılar</h2>
//               </div>
//               <p className="text-lg opacity-90 mb-6">
//                 2026 Teknoloji ve Eğitim Ödülleri'nde "En İnovatif Platform"
//                 seçildik. Kullanıcı memnuniyetinde sektör ortalamasının
//                 üzerindeyiz.
//               </p>
//               <div className="flex flex-wrap gap-4">
//                 <div className="flex items-center gap-2 bg-purple-500 px-4 py-2 rounded-full">
//                   <Star className="w-4 h-4 text-white" />
//                   <span>ISO 27001 Sertifikası</span>
//                 </div>
//                 <div className="flex items-center gap-2 bg-purple-500 px-4 py-2 rounded-full">
//                   <Star className="w-4 h-4 text-white" />
//                   <span>En İyi Startup 2026</span>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-purple-500 p-6 rounded-2xl backdrop-blur-sm">
//               <div className="text-center">
//                 <div className="text-5xl font-bold text-white mb-2">4.9/5</div>
//                 <div className="flex justify-center mb-2">
//                   {[...Array(5)].map((_, i) => (
//                     <Star
//                       key={i}
//                       className="w-5 h-5 text-yellow-300 fill-current"
//                     />
//                   ))}
//                 </div>
//                 <p className="text-white opacity-90">
//                   Kullanıcı Değerlendirmesi
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div> */}

//         {/* Sonuç */}
//         <div className="text-center max-w-3xl mx-auto">
//           <h3 className="text-3xl font-bold text-gray-900 mb-6">
//             Eğitimin geleceğini birlikte şekillendirelim
//           </h3>
//           <p className="text-gray-600 text-lg mb-8">
//             Her gün daha fazla öğretmen ve öğrenciye ulaşmanın heyecanıyla
//             çalışmaya devam ediyoruz. Siz de bu dönüşümün bir parçası olmak
//             ister misiniz?
//           </p>
//           {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <button
//               className="bg-purple-500 text-white font-semibold px-8 py-3
//              rounded-xl hover:bg-purple-600 transition-colors"
//             >
//               Platformu Keşfet
//             </button>
//             <button
//               className="bg-purple-500 text-white font-semibold px-8 py-3
//              rounded-xl border-2 border-putple-500 hover:bg-purple-600 transition-colors"
//             >
//               Demo Talep Et
//             </button>
//           </div> */}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default About;

import React from "react";
import {
  Users,
  Target,
  Award,
  Globe,
  BookOpen,
  Heart,
  TrendingUp,
  CheckCircle,
  Lightbulb,
  Shield,
  Clock,
  Star,
} from "lucide-react";

function About() {
  const teamMembers = [
    {
      name: "Ahmet Yılmaz",
      role: "Kurucu & CEO",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ahmet",
    },
    {
      name: "Zeynep Kaya",
      role: "Eğitim Direktörü",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Zeynep",
    },
    {
      name: "Mehmet Demir",
      role: "Teknoloji Lideri",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Mehmet",
    },
    {
      name: "Elif Şahin",
      role: "İçerik Geliştirme",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Elif",
    },
  ];

  const values = [
    {
      icon: <Heart className="w-6 h-6" />,
      title: "Öğrenci Odaklılık",
      description: "Her kararımızın merkezinde öğrenci başarısı var",
    },
    {
      icon: <Lightbulb className="w-6 h-6" />,
      title: "Yenilikçilik",
      description: "Eğitim teknolojilerinde sınırları zorluyoruz",
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Güvenilirlik",
      description: "Veri güvenliği ve gizlilik en yüksek önceliğimiz",
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "İşbirliği",
      description: "Birlikte daha iyisini başarıyoruz",
    },
  ];

  const milestones = [
    {
      year: "2026",
      title: "Kuruluş",
      description: "Classroom projesi başlatıldı",
    },
    {
      year: "2026",
      title: "Beta Yayın",
      description: "İlk 1000 kullanıcıya ulaşıldı",
    },
    {
      year: "2026",
      title: "Mobil Uygulama",
      description: "iOS ve Android uygulamaları yayınlandı",
    },
    {
      year: "2026",
      title: "100K+ Kullanıcı",
      description: "Türkiye genelinde yaygın kullanım",
    },
  ];

  return (
    <div className="min-h-screen  px-4 py-12">
      <div className="max-w-7xl mx-auto ">
        {/* Hero Bölümü */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 bg-purple-500
           text-white font-normal px-4 py-2 rounded-full mb-6"
          >
            <BookOpen className="w-5 h-5 text-yellow-300" />
            <span className="font-semibold">Eğitimde Devrim</span>
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
            Eğitimi<span className="text-gray-900"> Dönüştürüyoruz</span>
          </h1>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            2026'den beri öğretmen ve öğrencilerin buluştuğu dijital platform
            olarak, eğitim deneyimini yeniden tanımlıyoruz. Her gün binlerce
            sınıfı bir araya getiriyoruz.
          </p>
        </div>
        {/* Misyon & Vizyon */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <div className="bg-yellow-500 rounded-2xl p-8 shadow-xl border border-emerald-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-blue-100 p-3 rounded-full">
                <Target className="w-8 h-8 text-blue-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">Misyonumuz</h2>
            </div>
            <p className="text-white font-normal text-lg leading-relaxed mb-6">
              Her bireyin potansiyelini ortaya çıkaracak eğitim fırsatlarına
              erişimini sağlamak. Teknolojiyi kullanarak öğrenmeyi daha
              etkileşimli, erişilebilir ve keyifli hale getiriyoruz.
            </p>
            <ul className="space-y-3">
              {[
                "Erişilebilir eğitim",
                "Kişiselleştirilmiş öğrenme",
                "Sürekli yenilik",
                "Topluluk odaklı",
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-blue-600" />
                  <span className="text-white font-normal">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-purple-500 rounded-2xl p-8 shadow-xl border border-blue-100">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-blue-100 p-3 rounded-full">
                <Globe className="w-8 h-8 text-blue-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">Vizyonumuz</h2>
            </div>
            <p className="text-white font-normal text-lg leading-relaxed mb-6">
              2030 yılına kadar Türkiye'nin en etkili eğitim platformu olmak ve
              küresel çapta milyonlarca öğrenciye ulaşmak. Eğitimde dijital
              dönüşümün öncüsü olarak, geleceğin öğrenme deneyimini
              şekillendiriyoruz.
            </p>
            <div className="bg-blue-50 p-4 rounded-xl">
              <div className="flex items-center gap-3">
                <TrendingUp className="w-6 h-6 text-blue-600" />
                <div>
                  <h4 className="font-bold text-gray-900">Büyüme Hedefimiz</h4>
                  <p className="text-sm text-gray-600">
                    Önümüzdeki 3 yılda 1 milyon aktif kullanıcı
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Değerlerimiz */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Değerlerimiz
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Başarımızın arkasında yatan temel prensipler ve inandıklarımız
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-gray-100 rounded-2xl p-6 shadow-lg border border-gray-100 
                hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div
                  className="bg-purple-500 text-white w-14 h-14 
                rounded-xl flex items-center justify-center mb-4"
                >
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Tarihçe */}

        {/* Sonuç */}
        <div className="text-center max-w-3xl mx-auto">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">
            Eğitimin geleceğini birlikte şekillendirelim
          </h3>
          <p className="text-gray-600 text-lg mb-8">
            Her gün daha fazla öğretmen ve öğrenciye ulaşmanın heyecanıyla
            çalışmaya devam ediyoruz. Siz de bu dönüşümün bir parçası olmak
            ister misiniz?
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
